import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Lock, User, Shield } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const AdminLogin = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleInputChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Simple authentication (à remplacer par une vraie authentification)
    if (credentials.username === 'admin' && credentials.password === 'luxor2024') {
      toast({
        title: "Connexion réussie",
        description: "Bienvenue dans le panneau d'administration",
      });
      onLogin(true);
    } else {
      toast({
        title: "Erreur de connexion",
        description: "Nom d'utilisateur ou mot de passe incorrect",
        variant: "destructive"
      });
    }

    setIsLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <Shield className="mx-auto h-12 w-12 text-yellow-500 mb-4" />
          <h1 className="text-3xl font-bold text-white mb-2">
            Administration Luxor Limousine
          </h1>
          <p className="text-gray-400">
            Accès sécurisé au panneau d'administration
          </p>
        </div>

        <Card className="bg-white/10 backdrop-blur-md border-gray-700">
          <CardHeader>
            <CardTitle className="text-center text-white">
              Connexion Administrative
            </CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Nom d'utilisateur
                </label>
                <div className="relative">
                  <User className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                  <Input
                    type="text"
                    name="username"
                    value={credentials.username}
                    onChange={handleInputChange}
                    className="pl-10 bg-white/10 border-gray-600 text-white placeholder-gray-400 focus:border-yellow-500"
                    placeholder="Entrez votre nom d'utilisateur"
                    required
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Mot de passe
                </label>
                <div className="relative">
                  <Lock className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                  <Input
                    type="password"
                    name="password"
                    value={credentials.password}
                    onChange={handleInputChange}
                    className="pl-10 bg-white/10 border-gray-600 text-white placeholder-gray-400 focus:border-yellow-500"
                    placeholder="Entrez votre mot de passe"
                    required
                  />
                </div>
              </div>

              <Button
                type="submit"
                disabled={isLoading}
                className="w-full bg-yellow-500 hover:bg-yellow-600 text-black font-semibold py-3 disabled:opacity-50"
              >
                {isLoading ? 'Connexion...' : 'Se Connecter'}
              </Button>
            </form>

            <div className="mt-6 p-4 bg-blue-500/10 border border-blue-500/20 rounded-lg">
              <p className="text-sm text-blue-300 mb-2">
                <strong>Identifiants de test :</strong>
              </p>
              <p className="text-xs text-blue-200">
                Utilisateur : <code className="bg-blue-900/30 px-1 rounded">admin</code>
              </p>
              <p className="text-xs text-blue-200">
                Mot de passe : <code className="bg-blue-900/30 px-1 rounded">luxor2024</code>
              </p>
            </div>
          </CardContent>
        </Card>

        <div className="text-center mt-6">
          <p className="text-sm text-gray-400">
            © 2024 Luxor Limousine SA. Accès sécurisé.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;